import { Capacitor } from '~capacitor-plugins/core';

declare const DEVELOPMENT: boolean;
declare const STAGE: boolean;

export const canMockPrinting = Capacitor.getPlatform() === 'web' && (DEVELOPMENT || STAGE);
